import { render, staticRenderFns } from "./agregar.vue?vue&type=template&id=63782232"
import script from "./agregar.vue?vue&type=script&lang=js"
export * from "./agregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports